<template>
  <v-dialog v-model="dialogStatus" persistent width="650">
    <v-card>
      <v-card-title class="headline primary white--text" primary-title>
        {{ propEventoObj.TitoloEvento }}
        <v-spacer></v-spacer>
        {{ propEventoObj.TipoEventoDescrizione }}
      </v-card-title>
      <v-card-text>
        <v-layout row>
          <v-flex xs9>
            {{ Util.formattaData(propEventoObj.DataEvento) }}
            <span v-if="propEventoObj.CittaIndirizzo">- {{ propEventoObj.CittaIndirizzo }}</span>
            <div v-text="propEventoObj.AssociazioneDenominazione" class="text-xs-left accent--text"></div>
          </v-flex>
          <v-flex xs3>
            <div v-if="propEventoObj.TipologiaEvento != 'Gara'" class="text-xs-right">
              <v-chip v-if="propEventoObj.TipologiaEvento === 'Formazione'" small color="purple lighten-2" text-color="white">Formazione</v-chip>
              <v-chip v-else small color="orange lighten-2" text-color="white">Didattico</v-chip>
            </div>

            <div v-else class="text-xs-right">
              <v-chip v-if="propEventoObj.isOpen" small color="blue lighten-2" text-color="white">Open</v-chip>
              <v-chip v-else small color="red lighten-2" text-color="white">Ufficiale</v-chip>
            </div>
          </v-flex>
        </v-layout>
        <v-flex xs12 mb-2>
          <div class="py-3">{{ propEventoObj.DescrizioneEvento }}</div>
        </v-flex>
        <v-flex v-if="propListaAssociati" xs12 mb-2>
          <v-autocomplete v-model="associatoSelezionato" :items="associatiList" item-text="Denominazione" return-object box label="Tesserato" clearable hide-details>
            <template slot="item" slot-scope="data">
              <template v-if="typeof data.item !== 'object'">
                <v-list-tile-content v-text="data.item"></v-list-tile-content>
              </template>
              <template v-else>
                <v-list-tile-content>
                  <v-list-tile-title>
                    <span class="text-xs-left font-weight-bold">{{ data.item.NumeroTessera }}</span>
                    - {{ data.item.Denominazione }} / {{ data.item.CodiceFiscale }}
                    <v-avatar v-if="data.item.Open" size="20" color="cyan" small>
                      <span class="white--text xm">O</span>
                    </v-avatar>
                  </v-list-tile-title>
                </v-list-tile-content>
              </template>
            </template>
          </v-autocomplete>
        </v-flex>
        <v-flex v-if="propAggiungiIscritto === true" xs12 mb-2>
          <v-autocomplete v-model="StatoIscrizione" :items="statiIscrizione" box label="Stato Iscrizione" hide-details></v-autocomplete>
        </v-flex>

        <v-flex v-if="propAggiungiIscritto === true && (StatoIscrizione === 'Iscritto' || StatoIscrizione === 'Confermato' || StatoIscrizione === 'Pagato')" xs12 mb-2>
          <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" lazy transition="scale-transition" offset-y full-width max-width="290px" min-width="290px">
            <template v-slot:activator="{ on }">
              <v-text-field
                slot="activator"
                v-model="dateFormatted"
                @blur="date = Util.parseDate(dateFormatted)"
                v-on="on"
                box
                label="Data Iscrizione"
                hint="DD/MM/YYYY format"
                persistent-hint
                hide-details
                append-icon="event"
                required
              ></v-text-field>
            </template>
            <v-date-picker v-model="date" :max="propEventoObj.DataEvento" @input="menu1 = false" no-title></v-date-picker>
          </v-menu>
        </v-flex>

        <v-flex v-if="propAggiungiIscritto === true && StatoIscrizione === 'Pagato'" xs12 mb-2>
          <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false" lazy transition="scale-transition" offset-y full-width max-width="290px" min-width="290px">
            <template v-slot:activator="{ on }">
              <v-text-field
                slot="activator"
                v-model="dateFormatted2"
                @blur="date2 = Util.parseDate(dateFormatted2)"
                v-on="on"
                box
                label="Data Pagamento"
                hint="DD/MM/YYYY format"
                persistent-hint
                hide-details
                append-icon="event"
                required
              ></v-text-field>
            </template>
            <v-date-picker v-model="date2" :max="propEventoObj.DataEvento" @input="menu2 = false" no-title></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex v-if="propEventoObj.TipologiaEvento === 'Gara' && (associatoSelezionato != null ? (associatoSelezionato.Classe != 'PF' ? true :false) : true )" xs12>
          <v-autocomplete 
            v-model="categoriaSelezionata"
            :items="evento_ibo ? categorieIBO : evento_sto_eu ? categorieSTO_EU :  evento_sto ? categorieSTO : categorie"
            item-text="Descrizione"
            return-object
            box
            label="Categoria"
            clearable
            hide-details
          ></v-autocomplete>
        </v-flex>
        <v-flex v-else xs12>
          <v-autocomplete 
            v-model="categoriaSelezionata"
            :items="evento_ibo ? categoriePfIbo : categoriePf"
            item-text="Descrizione"
            return-object
            box
            label="Categoria"
            clearable
            hide-details
          ></v-autocomplete>
        </v-flex>
        <v-flex v-if="propEventoObj.TipologiaEvento === 'Gara'" xs12 mt-2>
          <v-autocomplete
            v-model="abbinamentoSelezionato"
            :items="propPartecipazioni"
            :disabled="!propPartecipazioni.length"
            item-text="Denominazione"
            item-value="iscrittoId"
            label="Abbinamento"
            class="abbinamenti"
            hide-details
            box
            clearable
          >
            <template slot="item" slot-scope="data">
              <template v-if="typeof data.item !== 'object'">
                <v-list-tile-content v-text="data.item"></v-list-tile-content>
              </template>
              <template v-else>
                <v-list-tile-content>
                  <v-list-tile-title v-html="data.item.Denominazione"></v-list-tile-title>
                  <v-list-tile-sub-title v-html="data.item.associazioneDenominazione + ' [<b>' + data.item.codiceCategoria + '</b>]'"></v-list-tile-sub-title>
                </v-list-tile-content>
              </template>
            </template>
          </v-autocomplete>
        </v-flex>
        <v-flex xs12 mt-2>
          <v-textarea v-model="note" box label="Note" auto-gorw clearable hide-details></v-textarea>
        </v-flex>
      </v-card-text>
      <v-card-actions class="grey lighten-3">
        <v-btn @click="closeDialog" flat>Chiudi</v-btn>
        <v-spacer></v-spacer>
        <v-btn
          v-if="propEventoObj.abilitatoPrenotazione && checkFunzione(elencoFunzioni.INSERIMENTO_PRENOTAZIONE_EVENTO) && !propEventoObj.IsIscritto && !propListaAssociati"
          @click="prenotaEvento(propEventoObj, userData.id, userData.Open, categoriaSelezionata, abbinamentoSelezionato, StatoIscrizione)"
          color="primary"
          >Prenota</v-btn
        >
        <v-btn
          v-else-if="propEventoObj.abilitatoPrenotazione && checkFunzione(elencoFunzioni.INSERIMENTO_PRENOTAZIONE_EVENTO) && propListaAssociati"
          :disabled="campiObbligatori && propAggiungiIscritto"
          @click="prenotaEvento(propEventoObj, associatoSelezionato.id, associatoSelezionato.Open == 1, categoriaSelezionata, abbinamentoSelezionato, StatoIscrizione)"
          color="primary"
          >Prenota Associato</v-btn
        >
        <v-btn
          v-else-if="
            showAnnulla &&
            propEventoObj.abilitatoPrenotazione &&
            propEventoObj.IsIscritto &&
            checkFunzione(elencoFunzioni.CANCELLAZIONE_PRENOTAZIONE_EVENTO) &&
            propEventoObj.StatoIscrizione == 'Prenotato'
          "
          color="red white--text"
          small
          flat
          >Annulla Prenotazione</v-btn
        >
        <v-btn
          v-else
          @click="prenotaEvento(propEventoObj, associatoSelezionato.id, associatoSelezionato.Open == 1, categoriaSelezionata, abbinamentoSelezionato, StatoIscrizione)"
          color="primary"
          >aggiungi partecipante</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import Util from '@/util';
  import { bus } from '@/main';
  import Security from '@/security';

  import * as moment from 'moment';

  export default {
    props: ['propEventoObj', 'propPartecipazioni', 'propListaAssociati', 'propStatus', 'propAggiungiIscritto'],
    data: function () {
      return {
        date: new Date().toISOString().substr(0, 10),
        dateFormatted: Util.formattaData(new Date().toISOString().substr(0, 10)),
        menu1: false,
        date2: new Date().toISOString().substr(0, 10),
        dateFormatted2: Util.formattaData(new Date().toISOString().substr(0, 10)),
        menu2: false,
        Util,
        elencoFunzioni: Security.enFunzione,
        ruoliUtente: Security.ruolo,
        categoriaSelezionata: null,
        associatoSelezionato: null,
        note: null,
        abbinamentoSelezionato: null,
        associatiList: [],
        dialogStatus: false,
        DataPrenotazioneStr: new Date().toISOString().substr(0, 10),
        DataPrenotazioneMenu: false,
        StatoIscrizione: '',
        statiIscrizione: ['Prenotato', 'Iscritto', 'Confermato', 'Pagato', 'Sospeso', 'Annullato', 'ListaAttesa'],
        rules: {
          data: (value) => !!value || 'Required.',
        },
      };
    },

    computed: {
      ...mapGetters('sharedModule', ['getCategorieEvento', 'getCategorieEventoEuropeo', 'getCategorieEventoIBO', 'getCategorieEventoSTO_EU', 'getCategorieEventoSTO']),
      ...mapGetters('associatiModule', ['getAssociati']),
      ...mapGetters(['userData']),

      campiObbligatori() {
        if ((this.StatoIscrizione === 'Iscritto' || this.StatoIscrizione === 'Confermato') && this.date != null) {
          return false;
        }
        if (this.StatoIscrizione === 'Pagato' && this.date != null && this.date2 != null) {
          return false;
        } else {
          return true;
        }
      },

      associati() {
        return this.getAssociati;
      },
      categorie() {
        return this.getCategorieEvento.filter((p) => {
          return p.Codice != 'RO' && p.Codice != 'FO' && p.Codice != 'DI';
        });
      },

      categoriePf() {
        return this.getCategorieEvento.filter((p) => {
          return p.Codice == 'RT';
        });
      },

      categoriePfIbo() {
        return this.getCategorieEventoIBO.filter((p) => {
          return p.Codice == 'FBH';
        });
      },

      categorieEuropeo() {
        return this.getCategorieEventoEuropeo.filter((p) => {
          return p.Codice != 'RO' && p.Codice != 'FO' && p.Codice != 'DI';
        });
      },

      categorieIBO() {
        return this.getCategorieEventoIBO;
      },

      categorieSTO_EU() {
        return this.getCategorieEventoSTO_EU;
      },

      categorieSTO() {
        return this.getCategorieEventoSTO;
      },

      categoriaFormazione() {
        return this.getCategorieEvento.filter((p) => {
          return p.Codice === 'FO';
        });
      },

      categorieEventoEuropeo() {
        return this.getCategorieEventoEuropeo.filter((p) => {
          return p.Codice != 'RO';
        });
      },

      evento_ibo() {
        if (this.propEventoObj && (this.propEventoObj.TipoEvento || this.propEventoObj.TipoEventoCodice)) {
          let codice = null;
          if (this.propEventoObj.TipoEventoCodice === undefined) {
            codice = this.propEventoObj.TipoEvento.Codice;
          } else {
            codice = this.propEventoObj.TipoEventoCodice;
          }
          if (codice === 'IBO_OUTDOOR' || codice === 'IBO_INDOOR' || codice === 'CI_IBO_INDOOR' || codice === 'CI_IBO_OUTDOOR' || codice ==='FIELD_IBO_OUTDOOR' || codice === 'National Indoor IBO' || codice === 'TC_IBO_OUTDOOR') {
            this.evento = true;
          } else {
            this.evento = false;
          }
        }
        return this.evento;
      },

      evento_sto_eu() {
        if (this.propEventoObj && (this.propEventoObj.TipoEvento || this.propEventoObj.TipoEventoCodice)) {
          let codice = null;
          if (this.propEventoObj.TipoEventoCodice === undefined) {
            codice = this.propEventoObj.TipoEvento.Codice;
          } else {
            codice = this.propEventoObj.TipoEventoCodice;
          }
          if (codice === 'ST_HISTORY_EU') {
            this.evento = true;
          } else {
            this.evento = false;
          }
        }
        return this.evento;
      },

      evento_sto() {
        if (this.propEventoObj && (this.propEventoObj.TipoEvento || this.propEventoObj.TipoEventoCodice)) {
          let codice = null;
          if (this.propEventoObj.TipoEventoCodice === undefined) {
            codice = this.propEventoObj.TipoEvento.Codice;
          } else {
            codice = this.propEventoObj.TipoEventoCodice;
          }
          if (codice === 'ST_HISTORY') {
            this.evento = true;
          } else {
            this.evento = false;
          }
        }
        return this.evento;
      },

      showAnnulla() {
        let retVal = false;
        if (this.propEventoObj) {
          const dataEvento = moment(this.propEventoObj.DataEvento);
          const dataAnnullamento = dataEvento.subtract(15, 'day');
          retVal = moment(new Date()).isSameOrBefore(dataAnnullamento);
        }
        return retVal;
      },
      computedDateFormatted(t) {
        return this.formatDate(t);
      },
    },

    watch: {
      date(val) {
        this.dateFormatted = this.formatDate(this.date);
      },
      date2(val) {
        this.dateFormatted2 = this.formatDate(this.date2);
      },
      abbinamenti(val, oldVal) {
        if (val.length > 3) {
          this.abbinamenti.pop();
        }
      },

      associati() {
        const isResponsabileEvento = this.userData.AssociazioneId == this.propEventoObj.AssociazioneId && this.userData.Role === this.ruoliUtente.RESPONSABILE_ASSOCIAZIONE;
        if (this.userData.AssociazioneId && this.propEventoObj.TipoEventoCodice === 'FOR') {
          this.associatiList = this.associati.filter((a) => {
            return a.isAttivo == 1 && a.StatoIscrizione == 'Iscritto';
          });
        } else if (this.userData.AssociazioneId && isResponsabileEvento === false) {
          this.associatiList = this.associati.filter((a) => {
            if (this.propEventoObj.isOpen) {
              return a.isAttivo == 1 && a.StatoIscrizione == 'Iscritto' && a.associazioneId == this.userData.AssociazioneId;
            } else {
              return a.isAttivo == 1 && a.StatoIscrizione == 'Iscritto' && a.associazioneId == this.userData.AssociazioneId && a.Open == 0;
            }
          });
        } else {
          this.associatiList = this.associati.filter((a) => {
            if (this.propEventoObj.isOpen) {
              return a.isAttivo == 1 && a.StatoIscrizione == 'Iscritto';
            } else {
              return a.isAttivo == 1 && a.StatoIscrizione == 'Iscritto' && a.Open == 0;
            }
          });
        }
        Util.sortArrayByKey(this.associatiList, 'Denominazione');
      },
      propStatus(val, oldVal) {
        this.dialogStatus = val;
        const isResponsabileEvento = this.userData.AssociazioneId == this.propEventoObj.AssociazioneId && this.userData.Role === this.ruoliUtente.RESPONSABILE_ASSOCIAZIONE;
        if (this.dialogStatus && this.propListaAssociati && this.propAggiungiIscritto === true && this.propEventoObj.TipoEventoCodice === 'FOR') {
          this.loadAssociati();
          this.categoriaSelezionata = null;
          this.associatoSelezionato = null;
          this.note = null;
          this.abbinamentoSelezionato = null;
        } else {
          if (this.userData.AssociazioneId && isResponsabileEvento == false) {
            this.loadAssociati(this.userData.AssociazioneId);
          } else {
            this.loadAssociati();
          }

          this.categoriaSelezionata = null;
          this.associatoSelezionato = null;
          this.note = null;
          this.abbinamentoSelezionato = null;
        }
      },
    },

    created() {
      this.loadTipologie();
    },

    methods: {
      ...mapActions('eventiModule', ['createPartecipazione', 'updatePartecipazione', 'updateEvento']),
      ...mapActions('associatiModule', ['loadAssociati']),
      ...mapActions('sharedModule', ['loadTipologie']),

      prenotaEvento(evento, idIscritto, isOpen, categoria, abbinamento, StatoIscrizione) {
        let catSelezionata;
        let statoIscrizioneSelezionato;
        if (this.propAggiungiIscritto === true || this.propEventoObj.TipoEventoCodice) {
          if (this.propEventoObj.TipoEventoCodice === 'FOR') {
            this.catSelezionata = 'FO';
            this.propAggiungiIscritto === true ? (this.statoIscrizioneSelezionato = StatoIscrizione) : (this.statoIscrizioneSelezionato = 'Prenotato');
          } else if (this.propEventoObj.TipoEventoCodice === 'DIDA') {
            this.catSelezionata = 'DI';
            this.propAggiungiIscritto === true ? (this.statoIscrizioneSelezionato = StatoIscrizione) : (this.statoIscrizioneSelezionato = 'Prenotato');
          } else if (this.propEventoObj.TipoEventoCodice != 'FOR' && this.propEventoObj.TipoEventoCodice != 'DIDA') {
            if (categoria != undefined && categoria != null) {
              if (categoria.Codice != undefined && categoria.Codice != null) {
                this.catSelezionata = categoria.Codice;
                if (!this.propEventoObj.isOpen && isOpen && this.propAggiungiIscritto != true) {
                  this.statoIscrizioneSelezionato = 'ListaAttesa';
                } else {
                  this.propAggiungiIscritto === true ? (this.statoIscrizioneSelezionato = StatoIscrizione) : (this.statoIscrizioneSelezionato = 'Prenotato');
                }
              }
            }
          }
        } else {
          if (this.propEventoObj.TipoEvento.Codice === 'FOR') {
            this.catSelezionata = 'FO';
            this.statoIscrizioneSelezionato = 'Prenotato';
          } else if (this.propEventoObj.TipoEvento.Codice === 'DIDA') {
            this.catSelezionata = 'DI';
            this.statoIscrizioneSelezionato = 'Prenotato';
          } else if (this.propEventoObj.TipoEvento.Codice != 'FOR' && this.propEventoObj.TipoEvento.Codice != 'DIDA') {
            if (categoria != undefined && categoria != null) {
              if (categoria.Codice != undefined && categoria.Codice != null) {
                this.catSelezionata = categoria.Codice;
                if (!this.propEventoObj.isOpen && isOpen) {
                  this.statoIscrizioneSelezionato = 'ListaAttesa';
                } else {
                  this.statoIscrizioneSelezionato = 'Prenotato';
                }
              }
            }
          }
        }
        this.iscrizioneObj = {
          IdEvento: evento.id,
          IdIscritto: idIscritto,
          StatoIscrizione: this.statoIscrizioneSelezionato,
          Categoria: this.catSelezionata,
          annosportivoId: evento.annosportivoId,
          isOpen: isOpen,
          UserPrenotazione: this.userData.userName,
          abbinamentoId: abbinamento,
          Note: this.note,
        };
        if (this.propAggiungiIscritto === true) {
          this.iscrizioneObj.DataIscrizione = this.date;
        }
        if (this.iscrizioneObj.StatoIscrizione === 'Pagato') {
          this.iscrizioneObj.DataPagamento = this.date2;
        }
        this.iscrizioneObj.DataPrenotazione = this.DataPrenotazioneStr;
        this.createPartecipazione(this.iscrizioneObj);

        this.StatoIscrizione = '';
      },

      modificaPartecipazione(evento, idIscritto, categoria, abbinamento) {
        let codiceCategoria = '';
        if (categoria != undefined && categoria != null) {
          if (categoria.Codice != undefined && categoria.Codice != null) {
            codiceCategoria = categoria.Codice;
          }
        }

        this.iscrizioneObj = {
          IdEvento: evento.id,
          annosportivoId: evento.annosportivoId,
          IdIscritto: idIscritto,
          Categoria: codiceCategoria,
          UserIscrizione: this.userData.userName,
          abbinamentoId: abbinamento,
        };
        this.updatePartecipazione(this.iscrizioneObj);
      },
      checkFunzione(func) {
        return Security.isAbilitata(func, this.userData.Role);
      },
      closeDialog(event) {
        bus.$emit('close-prenotazioneDialog', { status: false, update: false });
      },

      formatDate(t) {
        if (!t) return null;

        const [year, month, day] = t.split('-');
        return `${day}/${month}/${year}`;
      },
    },
  };
</script>

<style>
  .abbinamenti .v-select__selections {
    padding-top: 10px !important;
    min-height: 70px !important;
  }
</style>
